import type { FilterType } from "@/features/books/types";

export type BookFilterConfig = {
    label: string;
    type: FilterType;
    color: string; // Tailwind class name
};

export const BOOK_FILTER_CONFIG: Record<FilterType, BookFilterConfig> = {
    alreadyUsed: {
        color: "bg-green-600",
        label: "Already Used",
        type: "alreadyUsed",
    },
    neverUsed: {
        color: "bg-primary",
        label: "Never Used",
        type: "neverUsed",
    },
};
